module.exports = __webpack_public_path__ + "static/media/PdfIcon.0dc4917f.svg";